import { useSpring, a } from "@react-spring/web";
import { FC, ReactNode, useCallback, useState } from "react";
import styled from "styled-components";
import useMeasure from "../../hooks/useMeasure";
import { pxToRem } from "@input-output-hk/px-to-rem";
import ArrowDown from "../icons/ArrowDown";

// I really wanted to use <details /> here but it's pretty much impossible to
// control it and animate it in React
// https://github.com/facebook/react/issues/15486
const Element = styled(a.div)`
  overflow: hidden;
  display: flex;
  flex-flow: column nowrap;
`;

const Content = styled(a.div)`
  overflow: hidden;
`;

const TitleWrapper = styled.span``;

const ToggleButton = styled.button`
  border: 0;
  background: transparent;
  pointer-events: none;
  color: inherit;
`;

const ToggleIcon = styled(ArrowDown)`
  transition: transform 0.2s ease-out;

  &[data-is-open="true"] {
    transform: rotate(180deg);
  }
`;

const TitleRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${pxToRem(30)} var(--spacing-default) 0;
  cursor: pointer;

  &[open] ${ToggleIcon} {
    transform: rotate(180deg);
  }

  box-sizing: border-box;
`;

type Props = {
  title: ReactNode;
};

// thank to this CodeSandbox https://codesandbox.io/embed/lp80n9z7v9
const Accordion: FC<Props> = ({ title, children }) => {
  const [isOpen, open] = useState(true);

  const toggleOpen: React.ReactEventHandler = useCallback(() => {
    open((isOpen) => !isOpen);
  }, []);

  const [contentRef, { height: contentHeight }] = useMeasure();
  const { height } = useSpring({
    from: { height: 0 },
    to: { height: isOpen ? contentHeight : 0 }
  });

  return (
    <Element data-accordion>
      <TitleRow onClick={toggleOpen} title="toggle-button" data-accordion-title>
        <TitleWrapper>{title}</TitleWrapper>
        <ToggleButton>
          <ToggleIcon data-is-open={isOpen} />
        </ToggleButton>
      </TitleRow>

      <Content style={{ height }} data-accordion-content role="complementary">
        <div ref={contentRef}>{children}</div>
      </Content>
    </Element>
  );
};

export default Accordion;
